import React from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "@mui/material";

const KeywordHighlighter = ({
  content,
  keywords = [],
  onKeywordClick,
  highlightColor = "#DF7468",
}) => {
  if (!content) return null;

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const highlightKeywords = (text) => {
    if (!keywords || keywords.length === 0) return text;

    const parts = [];
    let lastIndex = 0;

    // Sort keywords by length (longest first) to handle overlapping matches
    const sortedKeywords = [...keywords].sort((a, b) => b.length - a.length);

    // Create a single regex pattern for all keywords
    const pattern = new RegExp(
      sortedKeywords.map((keyword) => `(${escapeRegExp(keyword)})`).join("|"),
      "gi"
    );

    // Find all matches
    const matches = Array.from(text.matchAll(pattern));

    matches.forEach((match) => {
      const keyword = match[0];
      const startIndex = match.index;
      const endIndex = startIndex + keyword.length;

      // Add text before the keyword
      if (startIndex > lastIndex) {
        parts.push(text.substring(lastIndex, startIndex));
      }

      // Add the highlighted keyword
      parts.push(
        <Link
          key={`${keyword}-${startIndex}`}
          component="span"
          onClick={() => onKeywordClick(keyword)}
          sx={{
            cursor: "pointer",
            color: highlightColor,
            textDecoration: "underline",
            "&:hover": {
              opacity: 0.8,
            },
          }}
        >
          {keyword}
        </Link>
      );

      lastIndex = endIndex;
    });

    // Add remaining text
    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex));
    }

    return parts;
  };

  return <>{highlightKeywords(content)}</>;
};

export default KeywordHighlighter;
